// extracted by mini-css-extract-plugin
export var chatHtmlText = "_q6-2";
export var chatLink = "_q6-0";
export var chatText = "_q6-1";